(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("QrScanner"), require("bootstrap"), require("mitt"), require("moment"), require("simpleDatatables"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , ], factory);
	else if(typeof exports === 'object')
		exports["ScanQrCode"] = factory(require("QrScanner"), require("bootstrap"), require("mitt"), require("moment"), require("simpleDatatables"));
	else
		root["ScanQrCode"] = factory(root["QrScanner"], root["bootstrap"], root["mitt"], root["moment"], root["simpleDatatables"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__143__, __WEBPACK_EXTERNAL_MODULE__744__, __WEBPACK_EXTERNAL_MODULE__218__, __WEBPACK_EXTERNAL_MODULE__916__, __WEBPACK_EXTERNAL_MODULE__259__) => {
return 